import { useConversationStore } from '#nora-chat-ui/stores/conversation/conversation-store';
import { useChatUserStore } from '#nora-chat-ui/stores/user-store';

/**
 * Checks whether the current user, stored in the userStore, has the specified permission. Optionally, you can make this call specific to a conversation.
 * @param permission
 * @param conversationId
 */
export function chatCan(permission: string, conversationId?: string | null): boolean {
  const userStore = useChatUserStore();

  if (!userStore.user) {
    return false;
  }

  if (!conversationId) {
    if (!userStore.user.permissions?.includes(permission)) {
      return false;
    }
  }
  else {
    if (userStore.user.permissions?.includes(permission)) {
      return true;
    }
    const conversationStore = useConversationStore();

    const permissions
      = conversationStore.getConversationPermissions(conversationId);

    if (!permissions) {
      return false;
    }

    if (!permissions.includes(permission)) {
      return false;
    }
  }

  return true;
}
